module.exports = __webpack_public_path__ + "static/media/hs_07.95042fa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_07.jpg
// module id = 5938
// module chunks = 0